import { render, staticRenderFns } from "./DepartmentSelectboxMultiple.vue?vue&type=template&id=246e9587"
import script from "./DepartmentSelectboxMultiple.vue?vue&type=script&lang=js"
export * from "./DepartmentSelectboxMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports